import ajax from '../utils/request'

const videoApi = {
    /********************************审核视频相关接口*********************************** */
    queryTagList(params) {
        return ajax({
            url: '/tag/pure/list',
            type: 'get',
            params: params
        })
    },
    subModuleList(params) {
        return ajax({
            url: '/module/conf/list',
            type: 'post',
            params: params
        })
    },
    getVideoList(params) {
        return ajax({
            url: '/vid/list',
            type: 'get',
            params: params
        })
    },
    // 视频删除接口
    deleteVideo(params) {
        return ajax({
            url: '/vid/del',
            type: 'delete',
            params: params
        })
    },
    // 单个视频审核接口
    examineVideo(params) {
        return ajax({
            url: '/vid/batch/pass',
            type: 'post',
            params: params
        })
    },
    // 批量视频审核接口
    batchReview(params) {
        return ajax({
            url: '/vid/batch/edit',
            type: 'post',
            params: params
        })
    },
    // 视频编辑
    editVideoInfo(params) {
        return ajax({
            url: '/vid/update',
            type: 'post',
            params: params
        })
    },
    // 推送为精选
    setChosen(params) {
        return ajax({
            url: '/vid/batch/update',
            type: 'post',
            params: params
        })
    },

    // 是否推荐
    setRecommend(params) {
        return ajax({
            url: '/vid/push',
            type: 'post',
            params: params
        })
    },
    // 取消推送
    cancelRecommend(params) {
        return ajax({
            url: '/vid/push/delete',
            type: 'post',
            params: params
        })
    },
    // 推送列表
    recommendList(params) {
        return ajax({
            url: '/vid/push/list',
            type: 'get',
            params: params
        })
    },

    // 视频上传
    uploadVideo(params) {
        return ajax({
            url: '/vid/submit',
            type: 'post',
            params: params
        })
    },
    // 精选视频推送
    pushVideo(params) {
        return ajax({
            url: '/vid/push',
            type: 'post',
            params: params
        })
    },
    // 审核不通过理由列表
    // 查询
    queryFailList(params) {
        return ajax({
            url: '/rejectTemp/vid/list',
            type: 'get',
            params: params
        })
    },
    // 新增
    addFailList(params) {
        return ajax({
            url: '/rejectTemp/vid/insert',
            type: 'post',
            params: params
        })
    },
    // 删除
    delFailList(params) {
        return ajax({
            url: '/rejectTemp/vid/del',
            type: 'post',
            params: params
        })
    },
    // 编辑
    editFailList(params) {
        return ajax({
            url: '/rejectTemp/vid/update',
            type: 'post',
            params: params
        })
    },
    // 视频审查
    videoFeviewList(params, urll) {
        return ajax({
            url: '/vid/view/' + urll,
            type: 'get',
            params: params
        })
    },


    /**
     * 断点续传视频验证是否分片上传完毕
     * @param {*} data
     */
    uploadDotJson(params) {
        return ajax({
            url: '/vid/uploadDotJson',
            type: 'post',
            params: params,
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }

        })
    },
    uploadDotStream(params) {
        return ajax({
            url: '/vid/uploadDotStream',
            type: 'post',
            params: params,
        })
    },
    /********************************城市列表*********************************** */
    // 删除城市
    deleteCity(params) {
        return ajax({
            url: '/vid/location/hotCity/delete',
            type: 'post',
            params: params
        })
    },
    // 获取城市列表
    getCityList(params) {
        return ajax({
            url: '/vid/location/city/list',
            type: 'get',
            params: params
        })
    },
    // 编辑
    updateCity(params) {
        return ajax({
            url: '/vid/location/city/update',
            type: 'post',
            params: params
        })
    },
    /********************************热门城市*********************************** */
    // 新增热门城市
    addHotCity(params) {
        return ajax({
            url: '/vid/location/hotCity/add',
            type: 'post',
            params: params
        })
    },
    // 删除热门城市
    deleteHotCity(params) {
        return ajax({
            url: '/vid/location/hotCity/delete',
            type: 'delete',
            params: params
        })
    },
    // 获取热门城市列表
    getHotCityList(params) {
        return ajax({
            url: '/vid/location/hotCity/list',
            type: 'get',
            params: params
        })
    },
    // 编辑热门城市
    editHotCity(params) {
        return ajax({
            url: '/vid/location/hotCity/update',
            type: 'post',
            params: params
        })
    },
    /********************************评论管理*********************************** */
    // 回复评论
    replyComment(params) {
        return ajax({
            url: '/comment/send',
            type: 'post',
            params: params
        })
    },
    replyContent(params) {
        return ajax({
            url: '/vid/update/summary',
            type: 'post',
            params: params
        })
    },
    updateNewsType(params) {
        return ajax({
            url: '/vid/update/newstype',
            type: 'post',
            params: params
        })
    },
    clearVideo(params) {
        return ajax({
            url: '/vid/update/image',
            type: 'post',
            params: params
        })
    },
    // 获取视频信息
    getVideoContentDetail(params) {
        return ajax({
            url: '/vid/detail',
            type: 'post',
            params: params
        })
    },
    // 回复评论
    leaveMessage(params) {
        return ajax({
            url: '/user/msg/send',
            type: 'post',
            params: params
        })
    },
    movieCert(params) {
        return ajax({
            url: '/user/videoCoupon',
            type: 'post',
            params: params
        })
    },
    // 请求评论管理模块配置列表
    getCommentList(params) {
        return ajax({
            url: '/comment/list',
            type: 'get',
            params: params
        })
    },
    // 请求评论管理模块封禁用户
    getCommentBan(params) {
        return ajax({
            url: '/comment/ban',
            type: 'post',
            params: params
        })
    },
    // 请求评论管理模块通过审核
    getCommentAccess(params) {
        return ajax({
            url: '/comment/access',
            type: 'post',
            params: params
        })
    },
    // 删除评论
    delComment(params) {
        return ajax({
            url: '/comment/delete',
            type: 'post',
            params: params
        })
    },
    // 删除评论
    delCommentId(params) {
        return ajax({
            url: '/comment/deletesgin',
            type: 'post',
            params: params
        })
    },
    // 根据评论内容删除评论
    deleteContent(params) {
        return ajax({
            url: '/web/comment/delete',
            type: 'post',
            params: params
        })
    },
    // 根据评论内容删除评论
    // upLoadContent(params) {
    //   return ajax({
    //     url: '/comment/importExcel',
    //     type: 'post',
    //     params: params
    //   })
    // },

    //导入评论内容
    iExcel(params) {
        return ajax({
            url: '/comment/importExcel',
            type: 'post',
            params: params
        })
    },
    /********************************短视频最热*********************************** */
    // 请求泡芙短视频最热模块配置列表
    getVideoHotList(params) {
        return ajax({
            url: '/vid/tone/list',
            type: 'get',
            params: params
        })
    },
    // 编辑泡芙短视频最热
    editVideoHot(params) {
        return ajax({
            url: '/vid/tone/update',
            type: 'post',
            params: params
        })
    },
    /********************************标签管理*********************************** */
    // 添加标签
    addTags(params) {
        return ajax({
            url: '/tag/add',
            type: 'post',
            params: params
        })
    },

    // 请求标签列表
    getTagList(params) {
        return ajax({
            url: '/tag/list',
            type: 'get',
            params: params
        })
    },

    // 请求推荐标签列表
    getRecmdList(params) {
        return ajax({
            url: '/recmd/list',
            type: 'get',
            params: params
        })
    },

    // 请求新增推荐标签
    addRecmdList(params) {
        return ajax({
            url: '/recmd/add',
            type: 'post',
            params: params
        })
    },

    // 编辑推荐标签
    editRecmdList(params) {
        return ajax({
            url: '/recmd/update',
            type: 'post',
            params: params
        })
    },

    // 删除推荐标签
    deleteRecmdList(params) {
        return ajax({
            url: '/recmd/delete',
            type: 'delete',
            params: params
        })
    },

    // 删除tags
    deleteTags(params) {
        return ajax({
            url: '/tag/delete',
            type: 'delete',
            params: params
        })
    },

    // 编辑标签
    editTags(params) {
        return ajax({
            url: '/tag/update',
            type: 'post',
            params: params
        })
    },

    // 推送至精彩
    pushWonder(params) {
        return ajax({
            url: '/vid/wonder/add',
            type: 'post',
            params: params
        })
    },

    /********************************发现精彩*********************************** */
    // 删除推荐精彩
    deleteWonder(params) {
        return ajax({
            url: '/vid/wonder/delete',
            type: 'delete',
            params: params
        })
    },

    // 获取精彩视频列表
    getWonderList(params) {
        return ajax({
            url: '/vid/wonder/list',
            type: 'get',
            params: params
        })
    },

    // 编辑发现精彩
    editWonder(params) {
        return ajax({
            url: '/vid/wonder/update',
            type: 'post',
            params: params
        })
    },

    // 编辑发现精彩
    getPlayLikeMax(params) {
        return ajax({
            url: '/vid/max',
            type: 'post',
            params: params
        })
    },

    /********************************资源管理*********************************** */
    // 删除资源
    deleteSource(params) {
        return ajax({
            url: '/source/del',
            type: 'delete',
            params: params
        })
    },

    // 获取资源列表
    getSourceList(params) {
        params["secret"] = "kL0)iU1^oA1#bI2(rQ8.dH9|uZ2!eN3#dS7=";
        return ajax({
            url: '/source/list',
            type: 'post',
            params: params
        })
    },

    // 添加资源
    addSource(params) {
        params["secret"] = "kL0)iU1^oA1#bI2(rQ8.dH9|uZ2!eN3#dS7=";
        return ajax({
            url: '/source/add',
            type: 'post',
            params: params
        })
    },

    // 编辑资源
    editSource(params) {
        params["secret"] = "kL0)iU1^oA1#bI2(rQ8.dH9|uZ2!eN3#dS7=";
        return ajax({
            url: '/source/edit',
            type: 'post',
            params: params
        })
    },

    /********************************过滤词管理*********************************** */
    // 过滤词列表
    filterList(params) {
        return ajax({
            url: '/filter/list',
            type: 'get',
            params: params
        })
    },

    // 过滤词删除
    filterDelete(params) {
        return ajax({
            url: '/filter/delete',
            type: 'delete',
            params: params
        })
    },
    // 过滤词添加
    filterAdd(params) {
        return ajax({
            url: '/filter/add',
            type: 'post',
            params: params
        })
    },


    /***********************免费视频观看配置列表************************ */
    // 过滤词列表
    // 删除
    deletefreeVid(params) {
        return ajax({
            url: '/freeVid/cfg/del',
            type: 'delete',
            params: params
        })
    },
    // 获取请求列表
    getfreeVidList(params) {
        return ajax({
            url: '/freeVid/cfg/list',
            type: 'get',
            params: params
        })
    },
    // 添加
    addfreeVid(params) {
        return ajax({
            url: '/freeVid/cfg/add',
            type: 'post',
            params: params
        })
    },
    // 编辑
    editfreeVid(params) {
        return ajax({
            url: '/freeVid/cfg/edit',
            type: 'post',
            params: params
        })
    },
}
export default videoApi
